import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { DrawerFooter } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as widgetTypesActions from 'store/widget-types/actions';
import Body from './Body';
import config from './config';

const EditWidgetType = ({ drawer, active }) => {
  const [disabled, setDisabled] = useState(false);
  const [updateWidgetType] = useActions([widgetTypesActions.updateWidgetType]);
  const { formState, loadValues, collectValues } = useForm(config);

  useEffect(() => {
    if (active) {
      loadValues({
        ...active
      });
    }
  }, [active, drawer.isOpen]);

  const submit = () => {
    const values = collectValues();
    setDisabled(true);
    if (!values) return;

    const { label, ...rest } = values;

    const params = {
      ...rest,
      id: active.id
    };
    updateWidgetType({ table: 'widget_types', ...params }).then(() => [
      setDisabled(false),
      drawer.close()
    ]);
  };
  return (
    <>
      <Body formState={formState} />
      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => {
            drawer.close();
          }}
          disabled={disabled}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={disabled} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </>
  );
};

export default EditWidgetType;
